import { Box } from "@material-ui/core";
import { format } from "date-fns";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import { useTranslate } from "react-polyglot";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    borderLeft: `2px solid ${theme.palette.borderColor.main}`,
    width: ({ expanded }) => (expanded ? 300 : 10),
    overflowY: ({ expanded }) => (expanded ? "auto" : "hidden"),
    overflowX: "hidden",
    position: "relative",
    "& hr": {
      borderStyle: "solid",
      height: 0,
      borderBottom: "2px solid",
      borderTop: 0,
      color: theme.palette.borderColor.main,
    },
  },
  header: {
    backgroundColor: ({ expanded }) => (expanded ? "#F0EFEF" : "transparent"),
    padding: 15,
    borderTopRightRadius: 7,
  },
  notesField: {
    marginTop: 5,
  },
  lastActivity: {
    whiteSpace: "nowrap",
  },
  hidePanel: {
    top: 0,
    left: 0,
    bottom: 0,
    position: "absolute",
    width: 10,
    zIndex: 1,
    cursor: "col-resize",
    transition: "background-color 0.3s ease",
    backgroundColor: ({ expanded }) => (expanded ? "transparent" : "#F0EFEF"),
    borderTopRightRadius: 9,
    borderBottomRightRadius: 9,
    "&:hover": {
      backgroundColor: "#F0EFEF",
    },
  },
}));

/** */
const UserDetails = () => {
  const [expanded, setExpanded] = useState(window.localStorage.getItem("chatUserDetailsExpanded") === "true");
  const t = useTranslate();
  const classes = useStyles({ expanded });
  const { selectedEmployeeInfo } = useChat();

  const lastOnline =
    (selectedEmployeeInfo?.lastOnline && format(selectedEmployeeInfo.lastOnline, "dd.MM.yyyy")) || "--.--.----";

  /** */
  const onPanelMouseDown = () => {
    setExpanded(!expanded);
    window.localStorage.setItem("chatUserDetailsExpanded", !expanded);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h5">{t("chat.profile")}</Typography>
      </Box>
      <Box padding="15px">
        <Typography variant="h6">
          <b>{selectedEmployeeInfo?.name}</b>
        </Typography>
        <br />
      </Box>
      <hr />
      <Box padding="15px">
        <Typography>
          {t("chat.lastActivity")} <span className={classes.lastActivity}>{lastOnline}</span>
        </Typography>
        <br />
      </Box>
      <hr />
      <Box className={classes.hidePanel} onMouseDown={onPanelMouseDown} />
    </Box>
  );
};

export default UserDetails;
